/**
 * PolicyPage — shared layout for BharatCart legal / policy documents.
 * Kept a single component so terms, privacy, refund, shipping and contact
 * all render with the same look-and-feel and Razorpay/Google/DPDP-friendly
 * structure (title, last-updated date, sections with anchor headings).
 */
import { Link } from 'react-router-dom';
import { ScrollText, ChevronRight } from 'lucide-react';

export default function PolicyPage({ title, subtitle, lastUpdated, sections }) {
  return (
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-10">
      {/* Breadcrumbs */}
      <nav className="text-xs text-ink/50 mb-4 inline-flex items-center gap-1" aria-label="Breadcrumb">
        <Link to="/" className="hover:text-[#D35400]">Home</Link>
        <ChevronRight className="w-3 h-3"/>
        <span className="text-ink/70 font-semibold">{title}</span>
      </nav>

      <div className="flex items-start gap-3 flex-wrap">
        <div className="w-12 h-12 rounded-xl bg-[#0D47A1] text-white grid place-items-center flex-shrink-0">
          <ScrollText className="w-6 h-6"/>
        </div>
        <div className="min-w-0">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#0D47A1]">BharatCart policy</div>
          <h1 className="font-heading font-black text-3xl md:text-4xl mt-1">{title}</h1>
          {subtitle && <p className="text-ink/70 mt-1 text-sm">{subtitle}</p>}
          <div className="text-[11px] text-ink/50 mt-2">Last updated: <b>{lastUpdated}</b> · Jurisdiction: Hyderabad, Telangana, India</div>
        </div>
      </div>

      <article className="mt-8 space-y-8 leading-relaxed text-[15px] text-ink/85">
        {sections.map((s, i) => (
          <section key={i} id={s.id}>
            <h2 className="font-heading font-bold text-xl text-ink">{i + 1}. {s.heading}</h2>
            <div className="mt-2 space-y-3">{s.body}</div>
          </section>
        ))}
      </article>

      <footer className="mt-12 pt-6 border-t border-border text-xs text-ink/60">
        <p><b>BharatCart Pvt. Ltd.</b> · Hyderabad, Telangana, 500034, India</p>
        <p>Grievance Officer: <a href="mailto:grievance@bharatcart.org" className="text-[#0D47A1] hover:underline">grievance@bharatcart.org</a> · Support: <a href="mailto:support@bharatcart.org" className="text-[#0D47A1] hover:underline">support@bharatcart.org</a> · <a href="tel:+911800000000" className="text-[#0D47A1] hover:underline">+91 1800-000-000</a> (10 AM – 8 PM IST, Mon–Sat)</p>
      </footer>
    </div>
  );
}
